/**
 * Created by lu on 2018/5/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:require('./RadioWrap'),
    slot:{
        inner:['html',{
            'class':'radio-item',
            'data-value':nb.bind('value'),
            tag:'span',
            $text:nb.bind('text')
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/RadioItem.js
// module id = 63
// module chunks = 0 2 3 8 9 15 22 23